import { render, staticRenderFns } from "./PrizeCard.vue?vue&type=template&id=f3e344b4&scoped=true&"
import script from "./PrizeCard.vue?vue&type=script&lang=js&"
export * from "./PrizeCard.vue?vue&type=script&lang=js&"
import style0 from "./PrizeCard.vue?vue&type=style&index=0&id=f3e344b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e344b4",
  null
  
)

export default component.exports